"use client";
import T from "@marginly/ui/components/typography";
import React from "react";

export function UnknownNetwork() {
  return <T headerL>Unknown network</T>;
}
